import React, { forwardRef, memo, RefObject, useCallback } from 'react';
import { StyledKey } from 'components/KeyboardSearch/StyledComponents';
import { IKeyMeta } from './languages';

interface IKey {
  keyMeta: IKeyMeta;
  content: string;
  onEnter: (keyMeta: Partial<IKeyMeta>) => void;
  ref: RefObject<HTMLAnchorElement>;
}

const Key: React.FC<IKey> = memo(
  forwardRef(({ keyMeta, content, onEnter }, ref) => {
    const handleEnter = useCallback(() => onEnter(keyMeta), [keyMeta, onEnter]);

    return (
      <StyledKey
        id={ref?.toString()}
        span={keyMeta.span}
        disabled={!content}
        onEnter={handleEnter}
        focusOnMouseEnter
        ref={ref}
      >
        {content || '-'}
      </StyledKey>
    );
  }),
);

export default Key;
